import ModalConfirmCode from './ModalConfirmCode';

export default ModalConfirmCode;
